import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Card,
  TextField,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { BASEURL } from '../../Constants';
import Nav from './nav';
import ToolsModal from './toolsModal'; // Import the modal component

const Tools = () => {
  const [toolsData, setToolsData] = useState([]);
  const [selectedTool, setSelectedTool] = useState(null); // State for selected tool
  const [modalOpen, setModalOpen] = useState(false); // State for modal open/close
  const navigate = useNavigate();
  const { pentest_id } = useParams();

  // Function to call the API and fetch detection data
  function getTools(token) {
    fetch(`${BASEURL}/pentest/tools/history?pentest_id=${pentest_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          if (data.message === 'Invalid token') {
            navigate('/');
          }
        } else {
          setToolsData(data.tools);
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
  }

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      getTools(token);
    } else {
      console.error('No token found');
      navigate('/');
    }
  }, []);

  const handleViewDetails = (tool) => {
    setSelectedTool(tool); // Set the selected tool's data
    setModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setSelectedTool(null); // Clear the selected tool
    setModalOpen(false); // Close the modal
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Main Content */}
      <Box sx={{ flexGrow: 1, padding: '20px', overflowX: 'auto' }}>
        {/* Header Section */}
        <Nav />

        <Card>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: 'left', fontWeight: 'bold', marginLeft: '20px', marginTop: '20px' }}
          >
            Tool History
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            sx={{ textAlign: 'left', marginLeft: '20px' }}
          >
            Below is a list of all the tools the pentest copilot has run. Click on a tool to view
            more details.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: '20px',
              marginBottom: '20px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                sx={{ width: '100%', marginRight: '10px' }}
                label="Search"
                variant="outlined"
                placeholder="Search pentests"
                size="small"
              />
              <Button variant="outlined" color="primary">
                Submit
              </Button>
            </Box>
          </Box>
          <TableContainer
            component={Paper}
            sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' }}
          >
            <Table>
              <TableHead sx={{ backgroundColor: '#005CC5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Time Stamp</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Command</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Assets Found</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Exploits Found</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {toolsData.length > 0 ? (
                  toolsData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:hover': {
                          backgroundColor: '#f3f3f3',
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 'bold' }}>{row.created_at}</TableCell>
                      <TableCell>{row.command}</TableCell>
                      <TableCell>{row.assets}</TableCell>
                      <TableCell>{row.exploits}</TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleViewDetails(row)} // Open modal with tool data
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          
          </TableContainer>
        </Card>
      </Box>

      {/* Modal */}
      <ToolsModal open={modalOpen} handleClose={handleCloseModal} tool={selectedTool} />
    </Box>
  );
};

export default Tools;
